// -----------------------------------------------------------------------------
// Hilfreiche Funktionen für Objekte
// -----------------------------------------------------------------------------

/**
 * Gibt zurück, ob alle Properties `true` sind
 *
 * @param oInput
 * @returns {boolean}
 */
const checkAndTrue = (oInput = {}) => {
  // Abbruch, falls kein Objekt übergeben wurde
  if (typeof oInput !== 'object' || oInput === null) {
    return false;
  }

  // Über alle Properties iterieren
  for (let key of Object.keys(oInput)) {
    // Abbruch, falls Eintrag vorhanden, welcher nicht `true` ist
    if (oInput[key] !== true) {
      return false;
    }
  }

  return true;
};

export {
  checkAndTrue
};
